if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            this.elements.button.addEventListener('click', this.openSelector.bind(this));
            this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
            this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
        }
        displayLocation(){
        }
        hidePanel() {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
            // Reset fixed positioning
            this.elements.panel.style.position = '';
            this.elements.panel.style.top = '';
            this.elements.panel.style.right = '';
            this.elements.panel.style.left = '';
            this.elements.panel.style.zIndex = '';
            this.elements.panel.style.maxHeight = '';
            this.elements.panel.style.overflowY = '';
        }
        onContainerKeyUp(event) {
            if (event.code.toUpperCase() !== 'ESCAPE') return;
            this.hidePanel();
            this.elements.button.focus();
        }
        onItemClick(event) {
            event.preventDefault();
            const form = this.querySelector('form');
            this.elements.input.value = event.currentTarget.dataset.value;
            if (form) form.submit();
        }
        openSelector(event) {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            const isOpen = !this.elements.panel.hasAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', isOpen.toString());
            
            if (isOpen) {
                // Use fixed positioning to escape all stacking contexts
                const btnRect = this.elements.button.getBoundingClientRect();
                this.elements.panel.style.position = 'fixed';
                this.elements.panel.style.top = (btnRect.bottom + 4) + 'px';
                this.elements.panel.style.right = (window.innerWidth - btnRect.right) + 'px';
                this.elements.panel.style.left = 'auto';
                this.elements.panel.style.zIndex = '999999';
                this.elements.panel.style.maxHeight = '400px';
                this.elements.panel.style.overflowY = 'auto';
                this.elements.panel.style.minWidth = '220px';
            }
        }
        closeSelector(event) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.hidePanel();
            }
        }
    }
    customElements.define('localization-form', LocalizationForm);
}
